import React, { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import Modal from '../components/Modal';
import MasterSelect from '../components/MasterSelect';
import HarvestFlow from '../components/HarvestFlow';

const UNITS = ['kg','ton','adet','litre','kasa','çuval'];
const QUALITIES = [
  { value: '1.sınıf', label: '🥇 1. Sınıf' },
  { value: '2.sınıf', label: '🥈 2. Sınıf' },
  { value: 'kırık',   label: '♻️ Kırık / Düşük' },
];

const EMPTY = {
  productName: '', quantity: '', unit: 'kg',
  qualityGrade: '1.sınıf', fieldId: '',
  harvestDate: new Date().toISOString().split('T')[0], notes: '',
  plantingId: '', seasonId: '',
};

export default function HarvestPage() {
  const [items, setItems] = useState([]);
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFlow, setShowFlow] = useState(false);
  const [prefill, setPrefill] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([
      api.get('/farm/harvests'),
      api.get('/farm/fields'),
    ]).then(([hr, fr]) => {
      setItems(hr.data.data);
      setFields(fr.data.data);
    }).catch(console.error).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  // Check for planting context (from PlantingsPage "Hasat Kaydet" button)
  useEffect(() => {
    const ctx = sessionStorage.getItem('harvestFromPlanting');
    if (ctx) {
      try {
        const p = JSON.parse(ctx);
        setPrefill({
          productName: p.productName || '',
          fieldId: p.fieldId || '',
          plantingId: p.plantingId || '',
          seasonId: p.seasonId || '',
        });
        setShowFlow(true);
      } catch {}
      sessionStorage.removeItem('harvestFromPlanting');
    }
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/farm/harvests', form);
      toast.success('Hasat kaydedildi 🌾');
      setShowModal(false);
      setForm(EMPTY);
      load();
    } catch { toast.error('Kaydedilemedi'); }
    finally { setSaving(false); }
  };

  const totalKg = items.reduce((s, i) => s + parseFloat(i.quantity || 0), 0);

  return (
    <div>
      <div className="card-row" style={{ marginBottom: 16 }}>
        <h2 className="section-title" style={{ margin: 0 }}>Hasat Kayıtları</h2>
        <span style={{ fontWeight: 800, color: '#2d5a27' }}>
          {new Intl.NumberFormat('tr-TR').format(totalKg)} kg
        </span>
      </div>

      <div className="card">
        {loading ? <div className="empty-state"><p>Yükleniyor...</p></div>
          : items.length === 0 ? (
            <div className="empty-state"><div className="icon">🌾</div><p>Henüz hasat kaydı yok</p></div>
          ) : items.map(item => (
            <div key={item.id} className="txn-item">
              <div className="txn-main">
                <div className="txn-name">{item.product_name}</div>
                <div className="txn-meta">
                  {new Date(item.harvest_date).toLocaleDateString('tr-TR')}
                  {item.field_name && ` · ${item.field_name}`}
                  {item.quality_grade && ` · ${item.quality_grade}`}
                </div>
              </div>
              <span style={{ fontWeight: 800, color: '#2d5a27', fontSize: '1rem' }}>
                {new Intl.NumberFormat('tr-TR').format(item.quantity)} {item.unit}
              </span>
            </div>
          ))}
      </div>

      <button className="btn-fab" onClick={() => { setPrefill(null); setShowFlow(true); }}>+</button>

      {showFlow && (
        <HarvestFlow
          onClose={() => { setShowFlow(false); setPrefill(null); }}
          onSaved={load}
          prefill={prefill}
        />
      )}
    </div>
  );
}
